import { Stack, StackPage, StackSwitch, StackSwitchApiContext, usePersistedStateId } from "@comet/admin";
import { AddCircleOutline } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { PageHeader } from "@src/components";
import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { AddCode } from "./add/Code";
import CsvImportForm from "./add/CsvImportForm ";
import Table from "./Table";
import { ViewCode } from "./view/Code";

export const AddButton = () => {
    const stackApi = useContext(StackSwitchApiContext);

    return (
        <Grid container spacing={4}>
            <Grid>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddCircleOutline style={{ fontSize: "20px" }} />}
                    onClick={() => stackApi.activatePage("import", "code")}
                >
                    <FormattedMessage id="reviermanager.page.codes.import" defaultMessage="Codes importieren" />
                </Button>
            </Grid>
            <Grid>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddCircleOutline style={{ fontSize: "20px" }} />}
                    onClick={() => stackApi.activatePage("add", "code")}
                >
                    <FormattedMessage id="reviermanager.page.codes.add" defaultMessage="Codes erstellen" />
                </Button>
            </Grid>
        </Grid>
    );
};

export default () => {
    const intl = useIntl();
    const persistedStateId = usePersistedStateId();
    return (
        <Stack topLevelTitle={intl.formatMessage({ id: "reviermanager.page.codes", defaultMessage: "Codes" })}>
            <StackSwitch initialPage="table">
                <StackPage name="table" title={intl.formatMessage({ id: "reviermanager.pages.codes", defaultMessage: "Codes" })}>
                    <PageHeader title={<FormattedMessage id="reviermanager.page.codes" defaultMessage="Codes" />} button={<AddButton />} />
                    <Table persistedStateId={persistedStateId} />
                </StackPage>
                <StackPage name="add" title={intl.formatMessage({ id: "reviermanager.page.codes.add", defaultMessage: "Codes erstellen" })}>
                    <AddCode />
                </StackPage>
                <StackPage name="import" title={intl.formatMessage({ id: "reviermanager.page.codes.import", defaultMessage: "Codes importieren" })}>
                    <CsvImportForm />
                </StackPage>
                <StackPage
                    name="information"
                    title={intl.formatMessage({ id: "reviermanager.pages.codes.information", defaultMessage: "Informationen" })}
                >
                    {(id) => <ViewCode id={id} />}
                </StackPage>
            </StackSwitch>
        </Stack>
    );
};
